<autocomplete-list-item (clicked)="triggerEvent()">
  <div class="header">{{ item.firstName }} {{ item.lastName }}</div>
  <div>{{ item.teamName }}</div>
</autocomplete-list-item>
